var _g, _g2, _g3, _g4, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConversor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.775,
    height: 69.381,
    viewBox: "0 0 71.775 69.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_247",
    "data-name": "Grupo 247",
    transform: "translate(159 373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_002-file",
    "data-name": " 002-file",
    transform: "translate(-159 -373)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Caminho_718",
    "data-name": "Caminho 718",
    transform: "translate(0 13.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_729",
    "data-name": "Caminho 729",
    d: "M232.271,720.907H253.8a5.98,5.98,0,0,0,5.98-5.979V688.607a1.211,1.211,0,0,0-.344-.852l-9.57-9.57a1.181,1.181,0,0,0-.852-.342H232.271a5.98,5.98,0,0,0-5.982,5.977v31.106a5.981,5.981,0,0,0,5.979,5.982Zm17.943-38.983,5.49,5.488h-1.9a3.6,3.6,0,0,1-3.589-3.589Zm-21.532,1.9a3.6,3.6,0,0,1,3.589-3.589h15.55v3.589A5.982,5.982,0,0,0,253.8,689.8h3.593v25.122a3.6,3.6,0,0,1-3.589,3.587H232.271a3.6,3.6,0,0,1-3.589-3.587Z",
    transform: "translate(-226.289 -677.842)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Caminho_719",
    "data-name": "Caminho 719",
    transform: "translate(38.281 13.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_730",
    "data-name": "Caminho 730",
    d: "M271.339,678.185a1.181,1.181,0,0,0-.852-.342H253.738a5.977,5.977,0,0,0-5.98,5.977v31.106a5.98,5.98,0,0,0,5.977,5.982h21.538a5.981,5.981,0,0,0,5.98-5.979V688.607a1.211,1.211,0,0,0-.344-.852Zm.344,3.739,5.49,5.488h-1.9a3.6,3.6,0,0,1-3.589-3.589Zm7.177,33a3.6,3.6,0,0,1-3.589,3.589H253.738a3.6,3.6,0,0,1-3.588-3.589v-31.1a3.6,3.6,0,0,1,3.588-3.589H269.29v3.589a5.98,5.98,0,0,0,5.977,5.982h3.593Z",
    transform: "translate(-247.758 -677.842)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Caminho_720",
    "data-name": "Caminho 720",
    transform: "translate(16.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_731",
    "data-name": "Caminho 731",
    d: "M265.588,677.639a1.2,1.2,0,0,0,1.2,1.2h5.98a1.2,1.2,0,0,0,1.2-1.2v-5.98a1.2,1.2,0,0,0-2.393,0v2.332a14.654,14.654,0,0,0-3.678-1.7,42.566,42.566,0,0,0-13.068-1.824,43.034,43.034,0,0,0-13.068,1.81c-5.025,1.674-6.071,3.843-6.071,5.367a1.2,1.2,0,0,0,2.391,0c0-1.944,6.521-4.786,16.748-4.786,8.254,0,14.1,1.854,16.044,3.589h-4.081A1.2,1.2,0,0,0,265.588,677.639Z",
    transform: "translate(-235.682 -670.462)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Caminho_721",
    "data-name": "Caminho 721",
    transform: "translate(16.748 61.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_732",
    "data-name": "Caminho 732",
    d: "M272.764,704.678a1.2,1.2,0,0,0-1.2,1.195c0,1.945-6.519,4.786-16.746,4.786-8.254,0-14.1-1.854-16.044-3.589h4.081a1.2,1.2,0,0,0,0-2.391h-5.984a1.2,1.2,0,0,0-1.195,1.195v5.982a1.2,1.2,0,0,0,2.391,0v-2.332a14.742,14.742,0,0,0,3.678,1.7,48.085,48.085,0,0,0,26.136,0c5.025-1.66,6.071-3.828,6.071-5.355A1.2,1.2,0,0,0,272.764,704.678Z",
    transform: "translate(-235.682 -704.678)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(11.966 29.927)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_245",
    "data-name": "Grupo 245",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_733",
    "data-name": "Caminho 733",
    d: "M239.03,696.113l-1.762-2.589-1.8,2.589a4.524,4.524,0,0,1-.663.774,1.026,1.026,0,0,1-.688.23,1.146,1.146,0,0,1-.788-.289.869.869,0,0,1-.325-.661,2.215,2.215,0,0,1,.5-1.095l2.2-3.149-1.949-2.623a1.965,1.965,0,0,1-.506-1.129.85.85,0,0,1,.3-.649,1.133,1.133,0,0,1,.792-.276,1.049,1.049,0,0,1,.708.241,4.421,4.421,0,0,1,.654.756l1.573,2.152,1.53-2.152a4.094,4.094,0,0,1,.663-.765,1.055,1.055,0,0,1,.7-.232,1.183,1.183,0,0,1,.8.271.836.836,0,0,1,.316.654,1.128,1.128,0,0,1-.13.528,4.084,4.084,0,0,1-.394.6l-1.949,2.623,2.2,3.149a2.319,2.319,0,0,1,.517,1.111.841.841,0,0,1-.321.66,1.173,1.173,0,0,1-.792.275,1.062,1.062,0,0,1-.706-.239A4.176,4.176,0,0,1,239.03,696.113Z",
    transform: "translate(-233 -687.246)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "y",
    transform: "translate(51.131 29.927)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_246",
    "data-name": "Grupo 246",
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_734",
    "data-name": "Caminho 734",
    d: "M258.283,697.42l.221-.542-2.988-7.525a2.813,2.813,0,0,1-.275-.943,1.1,1.1,0,0,1,.16-.578,1.176,1.176,0,0,1,.44-.426,1.149,1.149,0,0,1,.581-.161.953.953,0,0,1,.792.333,3.089,3.089,0,0,1,.473.956l2.054,5.977,1.947-5.558a9.371,9.371,0,0,1,.417-1.059,1.25,1.25,0,0,1,.4-.515,1.1,1.1,0,0,1,.592-.134,1.042,1.042,0,0,1,.53.146,1.027,1.027,0,0,1,.39.4,1.06,1.06,0,0,1,.139.526c-.025.112-.064.271-.116.48s-.119.417-.2.631l-3.167,8.288a9.7,9.7,0,0,1-.8,1.717,2.634,2.634,0,0,1-1.038.956,3.8,3.8,0,0,1-1.738.333,4.233,4.233,0,0,1-1.6-.23.845.845,0,0,1-.535-.845.828.828,0,0,1,.253-.646,1.107,1.107,0,0,1,.752-.226,1.37,1.37,0,0,1,.382.053,1.812,1.812,0,0,0,.4.054,1.436,1.436,0,0,0,.658-.125,1.16,1.16,0,0,0,.431-.431A6.708,6.708,0,0,0,258.283,697.42Z",
    transform: "translate(-254.965 -687.246)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversor);
export default __webpack_public_path__ + "static/media/conversor.2ad1623f7df3db48359397fda9c95794.svg";
export { ForwardRef as ReactComponent };